import type { ReactElement } from "react";
import { useAuth } from "@/core/auth/auth-provider";
import { Button } from "@/shared/components/ui";

// Gradient-header auth-control treatment (2026-08-22 product ruling; Figma
// navigation sheets / CLM wiki design source) — shared by Sign out and the
// public header's Sign in so the two controls cannot drift apart.
export const GRADIENT_AUTH_BUTTON_CLASSES =
  "border-white bg-transparent text-white hover:border-white hover:bg-white/15 hover:text-white";

export function UserMenu(): ReactElement {
  const auth = useAuth();
  const user = auth.session?.user;
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const displayName = user?.displayName ?? (fullName || user?.email) ?? "Unauthenticated";

  return (
    <div className="flex items-center gap-3 text-sm text-white" aria-label="User profile controls">
      <div className="min-w-0 text-right">
        <p className="truncate font-semibold">{displayName}</p>
        <p className="text-xs text-white/80">Session: {auth.status}</p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={GRADIENT_AUTH_BUTTON_CLASSES}
        onClick={() => void auth.logout()}
      >
        Sign out
      </Button>
    </div>
  );
}
